import { render, staticRenderFns } from "./ProcessingBanner.vue?vue&type=template&id=871606c2&"
import script from "./ProcessingBanner.vue?vue&type=script&lang=ts&"
export * from "./ProcessingBanner.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessingBanner.vue?vue&type=style&index=0&id=871606c2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports